import {InputFormatType} from "../../formability/form_builder/models/inputFormatType";
import assertNever from "../../global/assetNever";

export default class InputFormatDefinition {
  static getDisplayName(format: InputFormatType): string {
    switch (format) {
      case InputFormatType.None:
        return 'None';
      case InputFormatType.Numeric:
        return 'Numeric';
      case InputFormatType.Alphanumeric:
        return 'Alphanumeric';
      case InputFormatType.Email:
        return 'Email';
      case InputFormatType.Phone:
        return 'Phone';
      case InputFormatType.Zip:
        return 'Zip';
      case InputFormatType.Url:
        return 'Url (hyperlink)';
      case InputFormatType.Currency:
        return 'Currency';
      case InputFormatType.Pattern:
        return 'Regular Expression';
      case InputFormatType.SocialSecurity:
        return 'Social Security';
      case InputFormatType.Percentage:
        return 'Percentage';
      default:
        assertNever(format);
        break;
    }

    return null;
  }
}